module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "maintenance"
  }, [_c('h1', [_vm._v("Currently in maintenance mode")]), _vm._v(" "), _c('h2', [_vm._v("Please check back in a few minutes.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-99cee74e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Maintenance.vue
// module id = 2111
// module chunks = 2